"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aliasesTypeMap = exports.bytes = void 0;
const collections_1 = require("./collections");
/**
 * Alias for {@link uint8Array}.
 * @category TypeDefinition
 */
exports.bytes = collections_1.uint8Array;
exports.aliasesTypeMap = {
    // @ts-ignore
    bytes: collections_1.collectionsTypeMap.Uint8Array,
};
//# sourceMappingURL=aliases.js.map